import styles from '~/components/pc/PcPage.module.scss';
import { useLocale } from '~/hooks/useLocale';

export const PcPage = () => {
  const { lang } = useLocale();
  return <div className={styles.container} data-lang={lang} />;
};
